import { CoreCsvUploadType } from '@repo/csv'

export const ORDER_SERVICE_UPLOAD_TYPES: CoreCsvUploadType[] = [
  'material-upc-override',
  // 'erp-material-substitution',
  'limit-quantity',
  'limit-quantity-exemptions',
] as const
